import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'


const EmailMacro = ({ emailTemplate, processMacroList }) => {
    if (!emailTemplate || !processMacroList) {
        return null
    }
    return (
        <ContentBox title="Available Macros">
            <table className="default-table">
                <thead>
                    <tr>
                        <th>Macro</th>
                        <th>Explanation</th>
                        <th>Example</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        processMacroList.map(processMacro => {
                            return (
                                <tr key={processMacro.macro}>
                                    <td>{'{' + processMacro.macro + '}'}</td>
                                    <td>{processMacro.description}</td>
                                    <td>{processMacro.example}</td>
                                </tr>
                            )
                        })
                    }

                </tbody>
            </table>
        </ContentBox>
    )
}

EmailMacro.propTypes = {
    emailTemplate: PropTypes.object,
    processMacroList: PropTypes.array,
}

export default EmailMacro



// WEBPACK FOOTER //
// ./src/modules/email/component/manage/EmailMacro.js